/**
 * HTML uit legacy OpenCart-strings omzetten naar platte tekst of regels.
 */
export function stripHtmlToPlainText(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }
  if (typeof document !== 'undefined') {
    const el = document.createElement('div');
    el.innerHTML = html.replace(/<br\s*\/?>/gi, '\n');
    return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
  }
  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function splitHtmlLines(html) {
  if (!html || typeof html !== 'string') {
    return [];
  }
  return html
    .split(/<br\s*\/?>/gi)
    .map((part) => part.trim())
    .filter(Boolean);
}

/**
 * Combineert tekst_prijzen + alle_prijzen (legacy PHP met <br>).
 */
export function parseLegacyPriceLines(priceLabelHtml, pricesHtml) {
  const labels = splitHtmlLines(priceLabelHtml);
  const values = splitHtmlLines(pricesHtml);
  const count = Math.max(labels.length, values.length);
  const lines = [];

  for (let i = 0; i < count; i++) {
    const label = labels[i] ? stripHtmlToPlainText(labels[i]) : '';
    const valueHtml = values[i] || '';
    if (!label && !valueHtml) {
      continue;
    }
    lines.push({ label, valueHtml });
  }

  return lines;
}

/** Of de string al HTML-tags bevat (uit admin/legacy). */
export function looksLikeHtmlContent(text) {
  if (!text || typeof text !== 'string') {
    return false;
  }
  return /<[a-z][\s\S]*>/i.test(text);
}

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Kenmerktekst voor product-tab Specificaties: behoud regels en lijsten uit admin.
 * Platte tekst → escaped + &lt;br&gt;; bestaande HTML → ongewijzigd (+ eventuele \n).
 */
export function formatAttributeDisplayHtml(text) {
  if (!text || typeof text !== 'string') {
    return '';
  }
  const trimmed = text.trim();
  if (!trimmed) {
    return '';
  }

  if (looksLikeHtmlContent(trimmed)) {
    if (/\r\n|\r|\n/.test(trimmed) && !/<br\s*\/?>/i.test(trimmed)) {
      return trimmed.replace(/\r\n|\r|\n/g, '<br />');
    }
    return trimmed;
  }

  return escapeHtml(trimmed).replace(/\r\n|\r|\n/g, '<br />');
}

/**
 * Multi-regel attribuuttekst (zoals attribute_12 "Product Omschrijving") wordt
 * weergegeven als bullet-lijst onder Kenmerken. Bij één regel valt het terug
 * op de gewone weergave (formatAttributeDisplayHtml).
 */
export function formatAttributeListHtml(text) {
  if (!text || typeof text !== 'string') {
    return '';
  }
  const trimmed = text.trim();
  if (!trimmed) {
    return '';
  }

  let parts = splitHtmlLines(trimmed);
  if (parts.length <= 1 && /\r\n|\r|\n/.test(trimmed) && !/<br\s*\/?>/i.test(trimmed)) {
    parts = trimmed.split(/\r\n|\r|\n/);
  }

  const items = parts
    .map((p) => stripHtmlToPlainText(p) || p.replace(/<[^>]+>/g, '').trim())
    .filter(Boolean);

  if (items.length <= 1) {
    return formatAttributeDisplayHtml(text);
  }

  return (
    '<ul class="vsb-product-tabs__spec-list">' +
    items.map((line) => `<li>${escapeHtml(line)}</li>`).join('') +
    '</ul>'
  );
}
